import { createContext } from 'react'

export const ContentGroupPopupContext = createContext(null)
